module.exports = __webpack_public_path__ + "img/gb9123_5.prt.2404c05b.jpg";